export default __webpack_public_path__ + "static/media/dasboard-user-icon.e5b77fd2.svg";